import Management from './Management';

export default function ManagementPage() {
  return <Management />;
}
